import { useState } from 'react'
import Script from 'next/script'
import { ApolloProvider } from '@apollo/client/react'
import 'swiper/css'
import 'react-image-crop/lib/ReactCrop.scss'

import { DiscountProvider } from '../context/discountContext'
import { useApollo } from '@/utils/apolloClient'
import { useClickId } from '@/utils/clickId'

import '../ReactToastify.css'

export default function App({ Component, pageProps, err }) {
  const apolloClient = useApollo(pageProps.initialApolloState)
  const [isDiscountBannerClosed, setIsDiscountBannerClosed] = useState(false)

  useClickId(['gclid', 'fbclid'])

  return (
    <>
      <ApolloProvider client={apolloClient}>
        <DiscountProvider>
          <Component
            {...pageProps}
            err={err}
            isDiscountBannerClosed={isDiscountBannerClosed}
            setIsDiscountBannerClosed={setIsDiscountBannerClosed}
          />

          <style jsx global>
            {`
              html,
              body {
                margin: 0px;
                padding: 0px;
              }

              * {
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                font-family: 'Circular Std Book', Helvetica, Arial, sans-serif;
              }

              @font-face {
                font-family: 'Circular Std Blk';
                src: url('/fonts/Circular Std Blk.ttf');
                font-display: swap;
              }
              @font-face {
                font-family: 'Circular Std bld';
                src: url('/fonts/Circular Std Bold.ttf');
                font-display: swap;
              }
              @font-face {
                font-family: 'Circular Std Book';
                src: url('/fonts/Circular Std Book.ttf');
                font-display: swap;
              }
              @font-face {
                font-family: 'Circular Std Medium';
                src: url('/fonts/Circular Std Medium.ttf');
                font-display: swap;
              }
            `}
          </style>
        </DiscountProvider>
      </ApolloProvider>

      {/* Google Analytics */}

      <Script
        src="https://www.googletagmanager.com/gtag/js?id=G-2V7B3PZW9S"
        strategy="afterInteractive"
      />

      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-2V7B3PZW9S');
            gtag('config', 'AW-524247280');
          `,
        }}
      />

      {/* Google Tag Manager */}
      <Script
        id="gtm"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-WM6FVDK');
          `,
        }}
      />

      {/* Klaviyo */}
      <Script
        src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=U4g8WY"
        strategy="afterInteractive"
      />

      {/* Facebook Pixel */}
      <Script
        id="fb-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '317738702984602');
            fbq('track', 'PageView');
          `,
        }}
      />

      {/* Live Chat */}

      <Script
        id="live-chat"
        strategy="worker"
        dangerouslySetInnerHTML={{
          __html: `
              window.__lc = window.__lc || {};
              window.__lc.license = 13257255;
              ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))
              `,
        }}
      />
    </>
  )
}
